/** Time the thank-you / Lottie celebration stays on screen before `onComplete`. */
export const CELEBRATION_MS = 5000;
export const CELEBRATION_MS_REDUCED_MOTION = 1200;

export function getCelebrationHoldMs(autoCompleteMs?: number): number {
  if (autoCompleteMs != null) return autoCompleteMs;
  if (typeof window === "undefined") return CELEBRATION_MS;
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  return reduceMotion ? CELEBRATION_MS_REDUCED_MOTION : CELEBRATION_MS;
}


export const REDIRECT_BUFFER_AFTER_CELEBRATION_MS = 2000;
export function getThankYouRedirectDelayMs(
  autoCompleteMs?: number,
): number {
  return (
    getCelebrationHoldMs(autoCompleteMs) +
    REDIRECT_BUFFER_AFTER_CELEBRATION_MS
  );
}
